import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { Col, Form, Row } from "react-bootstrap";
import BatchOrderViewModel from "../../viewModels/multiEshop/batchOrderViewModel";
import { BatchOrderItemView } from "./batchOrderItemView";
import ErrorCard from "../common/error/errorCard";
import { PaymentError } from "../common/error/paymentError";

const batchOrderView: ViewComponent<BatchOrderViewModel> = observer(({ vm }) => {
  const error = (code: string) => vm.localizationService.translateGeneral(`errors.${code}`);
  const tpf = (code: string) => vm.localizationService.translateGeneral(`eshop.payment.status.failure.${code}`);

  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  if (vm.showPaymentErrorMessage) {
    return (
      <PaymentError
        title={vm.paymentErrorTitle}
        description={vm.paymentErrorDescription}
        showLink={vm.showPaymentErrorLink}
        buttonText={tpf("buttonText")}
        onClick={vm.closePaymentError}
      />
    );
  }

  return (
    <Form ref={formRef}>
      {vm.errorMessage && <ErrorCard message={error(vm.errorMessage)} sticky={true} />}
      <Row>
        <Col sm={12} lg={8}>
          {vm.children.map((itemVM, index) => (
            <BatchOrderItemView
              key={index}
              vm={itemVM}
              addOrderItem={vm.addOrderItem}
              removeOrderItem={vm.removeOrderItem}
              index={vm.children.length > 1 ? index : -1}
              lengthChildren={vm.children.length - 1}
            />
          ))}
        </Col>
        <Col sm={12} lg={4}>
          <View vm={vm.summaryViewModel} />
        </Col>
      </Row>
    </Form>
  );
});

registerView(batchOrderView, BatchOrderViewModel);
